// ======================================================================
// File Name       : MultiLanguageSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { MULTI_LANGUAGE_STATUS } from '../../constants/ContentConstant';
import RenderField from '../../utils/ReduxFormUtils';
import CustomButton from '../button/CustomButton';
import ReduxFormPaging from '../ReduxFormPaging';

class MultiLanguageSearch extends React.Component {

  render() {
    const {
      onSearchBtnClick,
    } = this.props;
    return (
      <div>
        <h3>検索する項目を指定してください</h3>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            onSearchBtnClick();
          }}
          className='form-horizontal'
        >
          <Col sm={12} className="padding-top-10 margin-bottom-15">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ識別ID
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="contentSecernId" label="コンテンツ識別ID" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コンテンツ名
              </Col>
              <Col sm={7}>
                <RenderField type="text" name="contentName" label="コンテンツ名" />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                ステータス
              </Col>
              <Col sm={9} className="padding-top-10">
                <RenderField
                  className="padding-top-clear"
                  name="multiLanguageStatus"
                  value={MULTI_LANGUAGE_STATUS.ALL}
                  type="radio"
                  label="全て"
                />
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="multiLanguageStatus"
                  value={MULTI_LANGUAGE_STATUS.AVAILABLE}
                  type="radio"
                  label="利用可能"
                />
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="multiLanguageStatus"
                  value={MULTI_LANGUAGE_STATUS.TRANSLATING_CONVERTING}
                  type="radio"
                  label="変換中"
                />
                <RenderField
                  className="margin-left-30 padding-top-clear"
                  name="multiLanguageStatus"
                  value={MULTI_LANGUAGE_STATUS.UNSELECT}
                  type="radio"
                  label="未選択"
                />
              </Col>
            </Form.Group>
            <Form.Group className="text-center">
              <Col sm={12}>
                <CustomButton
                  btnStyle="btn btn-primary btn-96 margin-top-20"
                  type="submit"
                  iconClass="bi bi-search"
                  text="検索"
                />
              </Col>
            </Form.Group>
          </Col>
        </Form>
      </div>
    );
  }
}

export default MultiLanguageSearch;
